import http from "../common/http-common";
import authHeader from '../common/auth-header';
import authHeaderPart from '../common/auth-header-part';

class FormationService {





    getAll(params) {
        //console.log(params);
        var headers = authHeader();
        let config = {
            headers,
            params: params,
        }
        //console.log(config)

        return http.get("/formations", config);
    }

    getAll2() {
        var headers = authHeader();
        let config = {
            headers,
        }
        //console.log(config)

        return http.get("/formations", config);
    }





    get(id) {
        var headers = authHeader();
        let config = {
            headers,
        }
        //console.log(config)
        return http.get(`/formations/${id}`, config);
    }

    create(item, fiche, convocation) {
        var headers = authHeaderPart();
        //console.log('create formation');
        //console.log(item);
        var FormData = require('form-data');
        var data = new FormData();
        data.append('fiche', fiche);
        data.append('convocation', convocation);
        data.append('formation',  JSON.stringify(item));

        //var raw = JSON.stringify(item);
        //console.log(data);
        let config = {
            headers,
        }
        return http.post("/formations", data, config);
    }

    update(id, item, fiche, convocation) {
        var headers = authHeaderPart();
        // console.log('event.target.name.value : '+event.target.name.value);
        //console.log('id');
        //console.log(id);
        //console.log('fiche');
        //console.log(fiche);
        //console.log('item');
        //console.log(item);
        var FormData = require('form-data');
        var data = new FormData();
        fiche ? data.append('fiche', fiche) : console.log('pas de fiche');
        convocation ? data.append('convocation', convocation) : console.log('pas de modele convocation');
        data.append('formation',  JSON.stringify(item));
        //console.log(data);
        let config = {
            headers,
        }
        return http.put(`/formations/${id}`, data, config);
    }


    delete(id) {
        var headers = authHeader();
        let config = {
            headers,
        }
        //console.log(config)
        return http.delete(`/formations/${id}`, config);
    }

    deleteAll() {
        return http.delete("/formations");
    }

    getFicheDocument(id) {

        var headers = authHeader();
        let config = {
            responseType: 'blob',
            headers,
        }
        //console.log(config)

        return http.get(`/formations/fiche/${id}`, config);
    }

    getConvocationDocument(name) {

        var headers = authHeader();
        let config = {
            responseType: 'blob',
            headers,
        }
        //console.log(config)

        return http.get(`/formations/convocation/${name}`, config);
    }





}

export default new FormationService();
